export default __webpack_public_path__ + "static/media/6_3.3c691e21.png";